import { render, staticRenderFns } from "./paymentPopup.vue?vue&type=template&id=2c6c905a"
import script from "./paymentPopup.vue?vue&type=script&lang=js"
export * from "./paymentPopup.vue?vue&type=script&lang=js"
import style0 from "./paymentPopup.vue?vue&type=style&index=0&id=2c6c905a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports